import { CAPTION_COLOR_CHOICES, captionColorChoice, isLegacyCaptionHex } from '@/lib/submission-zones';

type Props = {
  value: string;
  onChange: (next: string) => void;
  id?: string;
  'aria-label'?: string;
};

/**
 * Under-text color: Darkest logo color / Lightest logo color / White / Black.
 * A leftover custom hex is a fifth read/edit so old jobs are not lost.
 */
export function CaptionColorField({ value, onChange, id, 'aria-label': ariaLabel }: Props) {
  const current = captionColorChoice(value);
  const group = id || 'caption-color';
  const choices = isLegacyCaptionHex(current)
    ? [...CAPTION_COLOR_CHOICES, { value: current, label: current, legacy: true }]
    : [...CAPTION_COLOR_CHOICES];
  return (
    <div className="flex flex-wrap items-center gap-2" aria-label={ariaLabel || 'Under-logo color'}>
      {choices.map((c) => (
        <label
          key={c.value}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-[11px] text-muted"
        >
          <input
            type="radio"
            name={group}
            checked={current === c.value}
            onChange={() => onChange(c.value)}
          />
          {c.label}
          {'legacy' in c && c.legacy ? (
            <input
              type="color"
              aria-label="Stored custom color"
              title="Stored custom color"
              value={current}
              onChange={(e) => onChange(e.target.value.toUpperCase())}
              className="h-[22px] w-7 cursor-pointer rounded-[4px] border border-black/[0.08] bg-surface p-0.5"
            />
          ) : null}
        </label>
      ))}
    </div>
  );
}
